import { DataBean } from "../DataBean";

export class UBLPaymentMeansCode extends DataBean {

    public async getUBLPaymentMeansCode(idUBLPaymentMeansCode: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.ubl.UBLPaymentMeansCode_getUBLPaymentMeansCode_Number", [idUBLPaymentMeansCode]);
    }

    public async deleteUBLPaymentMeansCode(idUBLPaymentMeansCode: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteUBLPaymentMeansCode_Number", [idUBLPaymentMeansCode]);
    }

    public async getUBLPaymentMeansCodeCatalog(regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getUBLPaymentMeansCodeCatalog_String_Number_Number", [regexStr, page, recordsPerPage]);
    }

    public async getAvailableUBLPaymentMeansCodeCatalog(type: any, regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getAvailableUBLPaymentMeansCodeCatalog_Number_String_Number_Number", [type, regexStr, page, recordsPerPage]);
    }

}